import React from 'react';
import { Employee } from '../types';

interface ArchivedEmployee extends Employee {
  archivedAt: string;
}

interface Props {
  archived: ArchivedEmployee[];
  onRestore: (ids: string[]) => void;
  onClose: () => void;
}

const ArchiveModal: React.FC<Props> = ({ archived, onRestore, onClose }) => {
  const handleRestore = (id: string) => {
    onRestore([id]);
  };

  const daysLeft = (archivedAt: string) => {
    const archivedDate = new Date(archivedAt);
    const now = new Date();
    const msLeft = 7 * 24 * 60 * 60 * 1000 - (now.getTime() - archivedDate.getTime());
    return Math.max(Math.ceil(msLeft / (1000 * 60 * 60 * 24)), 0);
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-content archive-modal">
        <h3 style={{ marginBottom: '16px', textAlign: 'center' }}>Архив удаленных сотрудников</h3>

        {archived.length === 0 ? (
          <p>Архив пуст.</p>
        ) : (
          <>
            {/* Версия для ПК */}
            <div className="desktop-only">
              <table className="archive-table">
                <thead>
                  <tr>
                    <th style={{ textAlign: 'center' }}>ФИО</th>
                    <th style={{ textAlign: 'center' }}>Автоудаление</th>
                    <th style={{ textAlign: 'center' }}>Вернуть</th>
                  </tr>
                </thead>
                <tbody>
                  {archived.map((emp) => (
                    <tr key={emp.id}>
                      <td style={{ textAlign: 'center' }}>{emp.fullName}</td>
                      <td style={{ color: 'red', textAlign: 'center' }}>{daysLeft(emp.archivedAt)} дн.</td>
                      <td style={{ textAlign: 'center' }}>
                        <button onClick={() => handleRestore(emp.id)}>🔄</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Версия для мобильных устройств */}
            <div className="mobile-only">
              {archived.map((emp) => (
                <div className="archive-card" key={emp.id}>
                  <div><strong>ФИО:</strong> {emp.fullName}</div>
                  <div><strong>Удаление через:</strong> <span style={{ color: 'red' }}>{daysLeft(emp.archivedAt)} дн.</span></div>
                  <button className="restore-btn" onClick={() => handleRestore(emp.id)}>🔄 Вернуть</button>
                </div>
              ))}
            </div>
          </>
        )}

        <div style={{ textAlign: 'right', marginTop: '16px' }}>
          <button onClick={onClose} className="secondary-btn">Закрыть</button>
        </div>
      </div>
    </div>
  );
};

export default ArchiveModal;
